'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dAbstract$002dList from "./java.util.-Abstract-List.js";
var $p;
function $ct_ju_ArrayList__O__I__($thiz, innerInit, _size) {
  $thiz.Re = _size;
  $thiz.k3 = innerInit;
  $thiz.Rf = null;
  return $thiz;
}
export { $ct_ju_ArrayList__O__I__ as $ct_ju_ArrayList__O__I__ };
function $ct_ju_ArrayList__I__($thiz, initialCapacity) {
  if ((initialCapacity < 0)) {
    $j_java$002elang$002e$002dObject.$m_jl_BoundsChecks$().Pn(initialCapacity);
  }
  $ct_ju_ArrayList__O__I__($thiz, [], 0);
  return $thiz;
}
export { $ct_ju_ArrayList__I__ as $ct_ju_ArrayList__I__ };
function $ct_ju_ArrayList__($thiz) {
  $ct_ju_ArrayList__I__($thiz, 16);
  return $thiz;
}
export { $ct_ju_ArrayList__ as $ct_ju_ArrayList__ };
/** @constructor */
function $c_ju_ArrayList() {
  this.Re = 0;
  this.k3 = null;
  this.Rf = null;
}
export { $c_ju_ArrayList as $c_ju_ArrayList };
$p = $c_ju_ArrayList.prototype = new $j_java$002eutil$002e$002dAbstract$002dList.$h_ju_AbstractList();
$p.constructor = $c_ju_ArrayList;
/** @constructor */
function $h_ju_ArrayList() {
}
export { $h_ju_ArrayList as $h_ju_ArrayList };
$h_ju_ArrayList.prototype = $p;
$p.T = (function() {
  return (this.k3.length | 0);
});
$p.fS = (function(index) {
  var length = this.T();
  if (((index >>> 0) >= (length >>> 0))) {
    $j_java$002elang$002e$002dObject.$m_jl_BoundsChecks$().Pm(index, length);
  }
  return this.k3[index];
});
$p.Ct = (function(index, element) {
  var e = this.fS(index);
  this.k3[index] = element;
  return e;
});
$p.eP = (function(e) {
  (this.k3.push(e) | 0);
  return true;
});
$p.NQ = (function(index, element) {
  var length = this.T();
  if (((index >>> 0) > (length >>> 0))) {
    $j_java$002elang$002e$002dObject.$m_jl_BoundsChecks$().xt(index, length);
  }
  this.k3.splice(index, 0, element);
});
$p.us = (function(index) {
  var length = this.T();
  if (((index >>> 0) >= (length >>> 0))) {
    $j_java$002elang$002e$002dObject.$m_jl_BoundsChecks$().Pm(index, length);
  }
  var array = this.k3;
  return array.splice(index, 1)[0];
});
var $d_ju_ArrayList = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_ArrayList, "java.util.ArrayList", ({
  mQ: 1,
  dN: 1,
  bt: 1,
  aU: 1,
  bc: 1,
  bu: 1,
  ck: 1,
  nh: 1,
  J: 1,
  a: 1
}));
export { $d_ju_ArrayList as $d_ju_ArrayList };
